module.exports = __webpack_public_path__ + "static/media/asics-dia-das-maes.711b8693.png";